import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'app-help-faq-dialog-component',
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatExpansionModule],
  templateUrl: './help-faq-dialog-component.html',
  styleUrl: './help-faq-dialog-component.css',
})
export class HelpFaqDialogComponent { 

  readonly panelOpenState = signal(false);

}
